/* assets/ccs-favorites.js
 * Reorder-pad favorites: localStorage-first with optional Worker sync.
 * Vanilla, ES5-safe. Globals: window.CCSFavorites.
 */
(function () {
  'use strict';

  var KEY = 'ccs.favorites';
  var DEFAULT_EMPTY = { v: 1, items: [], updatedAt: new Date(0).toISOString() };

  function readLocal() {
    try {
      var raw = window.ccsLS.get(KEY);
      if (!raw) return clone(DEFAULT_EMPTY);
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.v !== 1 || !Array.isArray(parsed.items)) return clone(DEFAULT_EMPTY);
      return parsed;
    } catch (_) { return clone(DEFAULT_EMPTY); }
  }

  function writeLocal(payload) {
    payload.updatedAt = new Date().toISOString();
    window.ccsLS.set(KEY, JSON.stringify(payload));
    return payload;
  }

  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  function findIndex(items, vid) {
    for (var i = 0; i < items.length; i++) if (items[i].vid === vid) return i;
    return -1;
  }

  function toggleLocal(vid, qty, meta) {
    var state = readLocal();
    var idx = findIndex(state.items, vid);
    if (idx >= 0) {
      state.items.splice(idx, 1);
    } else {
      var entry = { vid: vid, qty: qty || 1, ts: new Date().toISOString() };
      if (meta) {
        if (meta.handle) entry.handle = meta.handle;
        if (meta.title)  entry.title  = meta.title;
        if (meta.image)  entry.image  = meta.image;
        if (meta.price)  entry.price  = meta.price;
        if (meta.vendor) entry.vendor = meta.vendor;
        /* Case/unit line-item props — same gating as ccs-card.js — so
           favorites adds merge into the same cart line as PDP/card adds. */
        if (meta.upc && parseInt(meta.upc, 10) > 1) entry.upc = meta.upc;
        if (meta.vol && parseInt(meta.vol, 10) > 0) entry.vol = meta.vol;
        if (meta.lbl) entry.lbl = meta.lbl;
      }
      state.items.push(entry);
    }
    return writeLocal(state);
  }

  function setQtyLocal(vid, qty) {
    var state = readLocal();
    var idx = findIndex(state.items, vid);
    if (idx < 0) return state;
    state.items[idx].qty = qty;
    state.items[idx].ts = new Date().toISOString();
    return writeLocal(state);
  }

  function removeLocal(vid) {
    var state = readLocal();
    var idx = findIndex(state.items, vid);
    if (idx < 0) return state;
    state.items.splice(idx, 1);
    return writeLocal(state);
  }

  function count() { return readLocal().items.length; }

  function has(vid) { return findIndex(readLocal().items, vid) >= 0; }

  function merge(local, server) {
    var by = {};
    function ingest(entry) {
      var existing = by[entry.vid];
      if (!existing || new Date(entry.ts) > new Date(existing.ts)) by[entry.vid] = entry;
    }
    (local.items || []).forEach(ingest);
    (server.items || []).forEach(ingest);
    var items = Object.keys(by).map(function (k) { return by[k]; });
    var localTs = local.updatedAt || new Date(0).toISOString();
    var serverTs = server.updatedAt || new Date(0).toISOString();
    return { v: 1, items: items, updatedAt: new Date(localTs) > new Date(serverTs) ? localTs : serverTs };
  }

  var api = {
    KEY: KEY,
    readLocal: readLocal,
    writeLocal: writeLocal,
    toggleLocal: toggleLocal,
    setQtyLocal: setQtyLocal,
    removeLocal: removeLocal,
    count: count,
    has: has,
    merge: merge,
  };

  function syncBadge() {
    var badges = document.querySelectorAll('[data-ccs-fav-count]');
    var c = count();
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(c);
      badges[i].setAttribute('aria-label', c + ' favorite' + (c === 1 ? '' : 's'));
      if (c > 0) badges[i].removeAttribute('hidden');
      else badges[i].setAttribute('hidden', '');
    }
  }

  function syncHeartStates() {
    var hearts = document.querySelectorAll('.ccs-fav-heart');
    for (var i = 0; i < hearts.length; i++) {
      var vid = parseInt(hearts[i].getAttribute('data-ccs-fav-vid'), 10);
      hearts[i].setAttribute('aria-pressed', has(vid) ? 'true' : 'false');
    }
  }

  function toast(msg) {
    if (window.ccsToast) window.ccsToast(msg);
    else if (window.console && window.console.log) window.console.log('[ccs-fav]', msg);
  }

  /* Read the product metadata we need to render a real card later from the
     DOM around the heart at toggle-time. This avoids needing a runtime variant→
     product lookup when rendering the favorites page (no Shopify API exposes a
     variant→handle map without admin auth). */
  function captureProductMeta(btn) {
    var meta = { handle: null, title: null, image: null, price: null, vendor: null, upc: null, vol: null, lbl: null };
    if (btn.classList.contains('ccs-fav-heart--md')) {
      var pm = location.pathname.match(/\/products\/([^/?#]+)/);
      if (pm) meta.handle = pm[1];
      var h1 = document.querySelector('h1');
      if (h1) meta.title = h1.textContent.trim();
      var mainImg = document.querySelector('.ccs-pdp-gallery img, .product__media img, [data-product-image] img, main img');
      if (mainImg) meta.image = mainImg.getAttribute('src') || mainImg.getAttribute('data-src');
      /* Scope the price lookup to the PDP buy box — a document-wide query can
         match a recommendation card's price and save the WRONG product's price.
         .pdp-price-main is the real buy-box price element (clean-care-product). */
      var buyBox = document.querySelector('.pdp-buy-box') || document.getElementById('pdp-price-region');
      var priceEl = buyBox ? buyBox.querySelector('.pdp-price-main, [data-vsel-price], .ccs-pdp-price, .price__regular .price-item, .price-item--regular') : null;
      if (priceEl) meta.price = (priceEl.textContent.match(/\$[\d,]+\.\d{2}/) || [null])[0];
      var vendEl = document.querySelector('.ccs-pdp-vendor, .product__vendor, [data-product-vendor]');
      if (vendEl) meta.vendor = vendEl.textContent.trim();
      var pdpAtc = document.querySelector('.pdp-btn-atc, .pdp-sticky-atc');
      if (pdpAtc) {
        meta.upc = pdpAtc.getAttribute('data-units-per-case');
        meta.vol = pdpAtc.getAttribute('data-volume-ml');
        meta.lbl = pdpAtc.getAttribute('data-unit-label');
      }
    } else {
      var card = btn.closest && btn.closest('.ccs-pc');
      if (card) {
        var href = card.getAttribute('href') || '';
        var hm = href.match(/\/products\/([^/?#]+)/);
        if (hm) meta.handle = hm[1];
        var nameEl = card.querySelector('.ccs-pc__name');
        if (nameEl) meta.title = nameEl.textContent.trim();
        var imgEl = card.querySelector('.ccs-pc__img img');
        if (imgEl) meta.image = imgEl.getAttribute('src') || imgEl.getAttribute('data-src');
        var priceEl2 = card.querySelector('.ccs-pc__price');
        if (priceEl2) meta.price = (priceEl2.textContent.match(/\$[\d,]+\.\d{2}/) || [null])[0];
        var brandEl = card.querySelector('.ccs-pc__brand');
        if (brandEl) meta.vendor = brandEl.textContent.trim();
        var atcForm = card.querySelector('.ccs-pc__atc-form');
        if (atcForm) {
          meta.upc = atcForm.getAttribute('data-units-per-case');
          meta.vol = atcForm.getAttribute('data-volume-ml');
          meta.lbl = atcForm.getAttribute('data-unit-label');
        }
      }
    }
    return meta;
  }

  window.ccsFavToggle = function (btn) {
    var vid = parseInt(btn.getAttribute('data-ccs-fav-vid'), 10);
    if (!vid) return;
    var qty = parseInt(btn.getAttribute('data-ccs-fav-qty'), 10) || 1;
    var pdpQtyEl = document.getElementById('pdp-qty');
    if (pdpQtyEl && btn.classList.contains('ccs-fav-heart--md')) {
      var parsed = parseInt(pdpQtyEl.value, 10);
      if (parsed > 0) qty = parsed;
    }
    var wasOn = has(vid);
    toggleLocal(vid, qty, wasOn ? null : captureProductMeta(btn));
    syncHeartStates();
    syncBadge();
    syncCarousel();
    queueSync();
    var event = wasOn ? 'ccs_favorite_removed' : 'ccs_favorite_added';
    if (window.Shopify && window.Shopify.analytics) {
      window.Shopify.analytics.publish(event, { variant_id: vid });
    }
    toast(wasOn ? 'Removed from favorites' : 'Saved to favorites');
  };

  var syncTimer = null;
  var syncFailCount = 0;
  var syncDisabled = false;
  var MAX_SYNC_FAILURES = 5;

  /* window.ccsFavAuth is seeded by snippets/ccs-favorites-seed.liquid on signed-in pages.
     Guests have no auth — queueSync is a no-op for them. */
  function queueSync() {
    if (!window.ccsFavAuth) return;
    if (syncDisabled) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { doSync(); }, 300);
  }

  function doSync() {
    var auth = window.ccsFavAuth;
    if (!auth || !auth.url) return;
    var payload = readLocal();
    /* Strip presentation metadata (handle/title/image/price/vendor) before
       sync — the Worker validator accepts {vid, qty, ts} only. Card metadata
       is a client-side UI cache, not server-of-record. */
    var syncPayload = {
      v: payload.v,
      updatedAt: payload.updatedAt,
      items: payload.items.map(function (it) {
        return { vid: it.vid, qty: it.qty, ts: it.ts };
      }),
    };
    var url = auth.url + '/favorites?cid=' + encodeURIComponent(auth.cid) +
              '&ts=' + encodeURIComponent(auth.ts) +
              '&token=' + encodeURIComponent(auth.token);
    if (!window.fetch) return;
    window.fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(syncPayload),
    }).then(function (res) {
      if (!res.ok) throw new Error('sync_' + res.status);
      syncFailCount = 0;
    }).catch(function () {
      syncFailCount++;
      if (syncFailCount >= MAX_SYNC_FAILURES) {
        syncDisabled = true;
        return;
      }
      var backoff = Math.min(30000, Math.pow(2, syncFailCount) * 1000);
      setTimeout(queueSync, backoff);
    });
  }

  function readSeed() {
    var el = document.getElementById('ccs-fav-seed');
    if (!el) return null;
    try {
      var text = el.textContent || el.innerText || '';
      return text ? JSON.parse(text) : null;
    } catch (_) { return null; }
  }

  function readAuth() {
    var el = document.getElementById('ccs-fav-auth');
    if (!el) return null;
    try {
      var text = el.textContent || el.innerText || '';
      return text ? JSON.parse(text) : null;
    } catch (_) { return null; }
  }

  function hydrate() {
    var auth = readAuth();
    if (auth && auth.url && auth.cid && auth.token) window.ccsFavAuth = auth;
    var seed = readSeed();
    if (!seed) return;
    var local = readLocal();
    var merged = merge(local, seed);
    writeLocal(merged);
    if (window.ccsFavAuth) queueSync();
    if (typeof window.CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent('ccs:fav-hydrated'));
    } else if (document.createEvent) {
      var ev = document.createEvent('Event');
      ev.initEvent('ccs:fav-hydrated', true, true);
      document.dispatchEvent(ev);
    }
  }

  function fetchVariant(vid) {
    return window.fetch('/variants/' + vid + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404) { var e = new Error('variant_404'); e.status = 404; throw e; }
        if (!r.ok) { var e2 = new Error('variant_' + r.status); e2.status = r.status; throw e2; }
        return r.json();
      });
  }

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2);
    return '$' + n;
  }

  function refreshPageChrome() {
    var hasFavView = document.getElementById('ccs-fav-list')
      || document.getElementById('ccs-fav-carousel')
      || document.getElementById('ccs-fav-shelf-carousel');
    var c = count();
    /* Hide the embedded shelf entirely when there are no favorites — empty
       carousels look like a broken page section. */
    var shelfSection = document.querySelector('[data-ccs-fav-shelf]');
    if (shelfSection) shelfSection.hidden = c === 0;
    if (!hasFavView) return;
    var empty = document.getElementById('ccs-fav-empty');
    var bulk = document.getElementById('ccs-fav-bulk-add');
    var banner = document.getElementById('ccs-fav-signin-banner');
    if (empty) empty.hidden = c > 0;
    if (bulk) bulk.disabled = c === 0;
    if (banner) banner.hidden = !(!window.ccsFavAuth && c > 0);
  }

  function renderRow(vid, qty, variant, meta) {
    var li = document.createElement('li');
    li.className = 'ccs-fav-row';
    li.setAttribute('data-vid', String(vid));
    /* Prefer the meta captured at heart-time — /variants/{id}.js returns no
       product_url/product_handle and featured_image is null for most variants. */
    var img = (meta && meta.image) || (variant.featured_image && variant.featured_image.src) || variant.image || '';
    var name = variant.name || variant.title || (meta && meta.title) || ('Variant ' + vid);
    var url;
    if (meta && meta.handle) url = '/products/' + meta.handle;
    else if (variant.product_url) url = variant.product_url;
    else if (variant.product_handle) url = '/products/' + variant.product_handle;
    else url = '/search?q=' + encodeURIComponent(name);
    var priceText = formatMoney(variant.price);

    var imgEl = document.createElement('img');
    imgEl.className = 'ccs-fav-row__img';
    if (img) imgEl.src = img;
    else imgEl.hidden = true; /* no src → hide, avoids broken-image icon */
    imgEl.alt = '';
    imgEl.loading = 'lazy';
    li.appendChild(imgEl);

    var body = document.createElement('div');
    var titleEl = document.createElement('a');
    titleEl.className = 'ccs-fav-row__title';
    titleEl.href = url;
    titleEl.textContent = name;
    body.appendChild(titleEl);
    var priceEl = document.createElement('div');
    priceEl.className = 'ccs-fav-row__price';
    priceEl.textContent = priceText;
    body.appendChild(priceEl);
    li.appendChild(body);

    var qtyWrap = document.createElement('div');
    qtyWrap.className = 'ccs-fav-row__qty';
    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.min = '1';
    qtyInput.max = '9999';
    qtyInput.value = String(qty);
    qtyInput.setAttribute('aria-label', 'Quantity');
    qtyWrap.appendChild(qtyInput);
    li.appendChild(qtyWrap);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'ccs-fav-row__remove';
    removeBtn.setAttribute('aria-label', 'Remove');
    removeBtn.textContent = '✕';
    li.appendChild(removeBtn);

    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (!v || v < 1) v = 1;
      if (v > 9999) v = 9999;
      qtyInput.value = String(v);
      setQtyLocal(vid, v);
      queueSync();
    });
    removeBtn.addEventListener('click', function () {
      removeLocal(vid);
      li.parentNode && li.parentNode.removeChild(li);
      syncBadge();
      syncHeartStates();
      refreshPageChrome();
      queueSync();
    });
    return li;
  }

  var renderGen = 0;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* Mirrors snippets/ccs-favorite-heart.liquid output so the heart inside a
     JS-rendered card behaves exactly like a Liquid-rendered one. */
  function buildHeartHtml(vid, qty) {
    var pathD = 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z';
    return '<button type="button" class="ccs-fav-heart ccs-fav-heart--sm" ' +
      'data-ccs-fav-vid="' + vid + '" data-ccs-fav-qty="' + qty + '" ' +
      'aria-label="Save to favorites" aria-pressed="true" ' +
      'onclick="event.stopPropagation(); event.preventDefault(); window.ccsFavToggle && window.ccsFavToggle(this)">' +
      '<svg class="ccs-fav-heart__outline" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + pathD + '"/></svg>' +
      '<svg class="ccs-fav-heart__filled" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="' + pathD + '"/></svg>' +
    '</button>';
  }

  /* Card markup mirroring snippets/ccs-product-card.liquid (default variant).
     Uses the same .ccs-pc* + .atc--card class names so the seed card's inline
     CSS styles these client-side cards identically. */
  function buildCardHtml(it) {
    var img = it.image || '';
    var name = it.title || ('Variant ' + it.vid);
    var url = it.handle ? '/products/' + it.handle : '#';
    var priceText = it.price || formatMoney(0);
    if (priceText && String(priceText).charAt(0) !== '$') priceText = '$' + priceText;
    var brand = it.vendor || '';
    var qty = it.qty || 1;

    return '<a class="ccs-pc ccs-pc--default" href="' + escapeHtml(url) + '">' +
      '<div class="ccs-pc__img">' +
        (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
        buildHeartHtml(it.vid, qty) +
      '</div>' +
      '<div class="ccs-pc__info">' +
        (brand ? '<div class="ccs-pc__brand-row"><span class="ccs-pc__brand">' + escapeHtml(brand.toUpperCase()) + '</span></div>' : '') +
        '<span class="ccs-pc__name">' + escapeHtml(name) + '</span>' +
        '<div class="ccs-pc__footer">' +
          '<div class="ccs-pc__prices">' +
            '<div class="ccs-pc__price-row">' +
              '<span class="ccs-pc__price">' + escapeHtml(priceText) + '</span>' +
            '</div>' +
            '<span class="ccs-pc__trade-lock"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>Trade pricing on request</span>' +
          '</div>' +
          /* Mirror the real product card's atc-row so the shared ccs-product-card.css
             + ccs-card.js + Quote Mode CSS all apply: retail = "Add to cart" (stepper),
             trade = promoted green "Add to Quote" + grey cart icon. (Was a lone
             .atc--card that ccs-card.js intercepted but couldn't drive — add-to-cart
             was effectively dead.) */
          '<div class="ccs-pc__atc-form" data-variant="' + it.vid + '"' +
            (it.upc ? ' data-units-per-case="' + escapeHtml(it.upc) + '"' : '') +
            (it.vol ? ' data-volume-ml="' + escapeHtml(it.vol) + '"' : '') +
            (it.lbl ? ' data-unit-label="' + escapeHtml(it.lbl) + '"' : '') +
            ' onclick="event.stopPropagation()">' +
            '<input type="hidden" name="id" value="' + it.vid + '">' +
            '<div class="atc-row">' +
              '<button type="button" class="atc atc--card js-atc-btn">Add to cart</button>' +
              '<button type="button" class="ccs-pc__quote-icon" ' +
                'onclick="event.preventDefault();event.stopPropagation();ccsAddToQuote(this.dataset.vid,1,{productHandle:this.dataset.handle,title:this.dataset.title,image:this.dataset.image,unit:this.dataset.unit||\'case\',kind:\'retail\'});" ' +
                'data-vid="' + it.vid + '" data-handle="' + escapeHtml(it.handle || '') + '" data-title="' + escapeHtml(name) + '" data-image="' + escapeHtml(img) + '" data-unit="' + escapeHtml((it.upc && parseInt(it.upc, 10) > 1) ? 'case' : (it.lbl || 'unit')) + '" aria-label="Add to quote list">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="4" width="12" height="17" rx="2"/><path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1"/></svg>' +
                '<span class="ccs-qm-label">Add to Quote</span>' +
              '</button>' +
              '<div class="qty qty--card" hidden>' +
                '<button type="button" class="qty__btn js-cart-dec" aria-label="Decrease quantity">−</button>' +
                '<span class="qty__num js-cart-num">1</span>' +
                '<button type="button" class="qty__btn js-cart-inc" aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</a>';
  }

  /* For items that pre-date captureProductMeta (saved with only {vid, qty, ts}),
     enrich them by combining the variant API (gives us name + price) with a
     predictive-search lookup (gives us handle + image + vendor). Predictive
     search is the only public Shopify endpoint that maps a product name to its
     handle without admin auth, so we query by variant.name. The enriched
     payload is also persisted back to localStorage so the upgrade is one-time
     per item. */
  function enrichLegacyItem(it) {
    return fetchVariant(it.vid).then(function (variant) {
      var name = variant.name || variant.title || '';
      var fallback = {
        vid: it.vid,
        qty: it.qty,
        ts: it.ts,
        title: name || ('Variant ' + it.vid),
        price: formatMoney(variant.price),
        image: null,
        handle: null,
        vendor: null,
      };
      if (!name || !window.fetch) return fallback;
      return window.fetch('/search/suggest.json?q=' + encodeURIComponent(name) + '&resources[type]=product&resources[limit]=1', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (json) {
        var products = json && json.resources && json.resources.results && json.resources.results.products;
        var p = products && products[0];
        if (!p) return fallback;
        var handle = null;
        if (p.handle) handle = p.handle;
        else if (p.url) {
          var m = p.url.match(/\/products\/([^/?#]+)/);
          if (m) handle = m[1];
        }
        return {
          vid: it.vid,
          qty: it.qty,
          ts: it.ts,
          title: p.title || fallback.title,
          price: p.price || fallback.price,
          image: p.image || fallback.image,
          handle: handle,
          vendor: p.vendor || fallback.vendor,
        };
      }).catch(function () { return fallback; });
    });
  }

  function persistEnrichedItem(enriched) {
    var state = readLocal();
    var idx = findIndex(state.items, enriched.vid);
    if (idx < 0) return;
    var existing = state.items[idx];
    state.items[idx] = {
      vid: existing.vid,
      qty: existing.qty,
      ts: existing.ts,
      title: enriched.title || existing.title,
      price: enriched.price || existing.price,
      image: enriched.image || existing.image,
      handle: enriched.handle || existing.handle,
      vendor: enriched.vendor || existing.vendor,
    };
    /* Preserve case/unit line-item props captured at heart-time. */
    if (existing.upc) state.items[idx].upc = existing.upc;
    if (existing.vol) state.items[idx].vol = existing.vol;
    if (existing.lbl) state.items[idx].lbl = existing.lbl;
    writeLocal(state);
  }

  /* Stored card prices are snapshots captured at heart-time; cheaply
     re-validate against the live product JSON so a reprice or sale after
     saving can't show a stale dollar amount forever. At most one fetch per
     item per page load; failures are silent (snapshot stays). */
  var priceRevalidated = {};
  function revalidatePrice(it, wrapper) {
    if (!it.handle || !window.fetch) return;
    if (priceRevalidated[it.vid]) return;
    priceRevalidated[it.vid] = true;
    window.fetch('/products/' + encodeURIComponent(it.handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;
        var match = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(it.vid)) { match = product.variants[i]; break; }
        }
        if (!match || typeof match.price !== 'number') return;
        var live = formatMoney(match.price);
        var stored = String(it.price || '');
        if (stored && stored.charAt(0) !== '$') stored = '$' + stored;
        if (stored === live) return;
        var state = readLocal();
        var idx = findIndex(state.items, it.vid);
        if (idx >= 0 && state.items[idx].price !== live) {
          state.items[idx].price = live;
          writeLocal(state);
        }
        if (wrapper && wrapper.parentNode) {
          var priceEl = wrapper.querySelector('.ccs-pc__price');
          if (priceEl) priceEl.textContent = live;
        }
      })
      .catch(function () { /* silent — keep the snapshot until next load */ });
  }

  function appendCardItem(carousel, it, gen) {
    var wrapper = document.createElement('div');
    wrapper.className = 'ccs-fav-card-item';
    wrapper.setAttribute('data-vid', String(it.vid));
    carousel.appendChild(wrapper);

    if (it.handle && it.image) {
      wrapper.innerHTML = buildCardHtml(it);
      syncHeartStates();
      revalidatePrice(it, wrapper);
      return;
    }

    /* Pre-captureProductMeta item or hydrated server seed with no card meta.
       Async-enrich via variant API + predictive search so the card gets a
       real PDP URL, image, and vendor. Persist the result so the upgrade is
       one-shot per item. */
    enrichLegacyItem(it).then(function (enriched) {
      if (gen !== renderGen || !wrapper.parentNode) return;
      persistEnrichedItem(enriched);
      wrapper.innerHTML = buildCardHtml(enriched);
      syncHeartStates();
    }).catch(function (err) {
      if (gen !== renderGen) return;
      if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
      if (err && err.status === 404) {
        removeLocal(it.vid);
        syncBadge();
        refreshPageChrome();
        queueSync();
      }
    });
  }

  function renderCarousel(carousel) {
    var gen = ++renderGen;
    carousel.innerHTML = '';
    var state = readLocal();
    state.items.forEach(function (it) {
      appendCardItem(carousel, it, gen);
    });
    refreshPageChrome();
    bindBulkAdd();
  }

  function syncCarousel() {
    /* Both the /pages/favorites carousel AND the PDP shelf carousel — the
       shelf (#ccs-fav-shelf-carousel) must reconcile on heart toggles too,
       or stale cards linger and the shelf never appears/hides. */
    var carousels = [];
    var page = document.getElementById('ccs-fav-carousel');
    if (page) carousels.push(page);
    var shelf = document.getElementById('ccs-fav-shelf-carousel');
    if (shelf) carousels.push(shelf);
    if (!carousels.length) return;
    var state = readLocal();
    var vids = state.items.map(function (it) { return String(it.vid); });
    carousels.forEach(function (carousel) {
      var present = {};
      var children = Array.prototype.slice.call(carousel.children);
      children.forEach(function (card) {
        var v = card.getAttribute('data-vid');
        if (!v) return;
        if (vids.indexOf(v) === -1) card.parentNode.removeChild(card);
        else present[v] = true;
      });
      /* Append cards for newly-hearted items so a first heart on a PDP
         reveals a populated shelf, not an empty rail. */
      state.items.forEach(function (it) {
        if (!present[String(it.vid)]) appendCardItem(carousel, it, renderGen);
      });
    });
    refreshPageChrome();
  }

  function renderPage() {
    /* Render every favorites view present on the page. Most pages have at most
       one — /pages/favorites has the full carousel, PDPs have the shelf, the
       signed-in portal has the row list. They never co-exist in practice but
       handle both defensively. */
    var carousel = document.getElementById('ccs-fav-carousel');
    if (carousel) renderCarousel(carousel);
    var shelf = document.getElementById('ccs-fav-shelf-carousel');
    if (shelf) renderCarousel(shelf);
    if (carousel || shelf) {
      refreshPageChrome();
      bindBulkAdd();
      if (!document.getElementById('ccs-fav-list')) return;
    }
    var list = document.getElementById('ccs-fav-list');
    if (!list) return;
    var gen = ++renderGen;
    list.innerHTML = '';
    var state = readLocal();
    state.items.forEach(function (it) {
      fetchVariant(it.vid).then(function (variant) {
        if (gen !== renderGen) return;
        if (!document.getElementById('ccs-fav-list')) return;
        var row = renderRow(it.vid, it.qty, variant, it);
        list.appendChild(row);
      }).catch(function (err) {
        if (gen !== renderGen) return;
        if (err && err.status === 404) {
          removeLocal(it.vid);
          syncBadge();
          refreshPageChrome();
          queueSync();
        }
      });
    });
    refreshPageChrome();
    bindBulkAdd();
  }

  function bindBulkAdd() {
    var bulkBtn = document.getElementById('ccs-fav-bulk-add');
    if (!bulkBtn || bulkBtn.getAttribute('data-ccs-fav-bound')) return;
    bulkBtn.setAttribute('data-ccs-fav-bound', '1');
    bulkBtn.addEventListener('click', function () {
      var state = readLocal();
      if (state.items.length === 0) return;
      var items = state.items.map(function (it) {
        var entry = { id: it.vid, quantity: it.qty };
        /* ccsAddManyToCart re-gates these (upc>1, vol>0) before sending. */
        if (it.upc) entry.units_per_case = it.upc;
        if (it.vol) entry.volume_ml = it.vol;
        if (it.lbl) entry.unit_label = it.lbl;
        return entry;
      });
      if (window.ccsAddManyToCart) {
        window.ccsAddManyToCart(items, bulkBtn);
        if (window.Shopify && window.Shopify.analytics) {
          window.Shopify.analytics.publish('ccs_favorite_bulk_added_to_cart', { count: items.length });
        }
      }
    });
  }

  api.formatMoney = formatMoney;
  api.renderPage = renderPage;

  function init() {
    hydrate();
    syncHeartStates();
    syncBadge();
    document.addEventListener('ccs:fav-hydrated', function () { syncHeartStates(); syncBadge(); renderPage(); });
    if (window.addEventListener) {
      window.addEventListener('storage', function (e) {
        if (e.key === KEY) {
          syncHeartStates();
          syncBadge();
          renderPage();
        }
      });
    }
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  api.queueSync = queueSync;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    window.CCSFavorites = api;
  }
}());
